import { render, staticRenderFns } from "./JsonCell.vue?vue&type=template&id=967df6aa&scoped=true"
import script from "./JsonCell.vue?vue&type=script&lang=js"
export * from "./JsonCell.vue?vue&type=script&lang=js"
import style0 from "./JsonCell.vue?vue&type=style&index=0&id=967df6aa&prod&lang=scss&scoped=true"
import style1 from "./JsonCell.vue?vue&type=style&index=1&id=967df6aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967df6aa",
  null
  
)

export default component.exports